/**
 * API 相关常量
 */

// 后端接口状态码
export const API_CODE = {
  SUCCESS: 0, // 成功
  ERROR: 1, // 错误
  TOKEN_EXPIRED: 1002, // Token 过期
  BANNED_WORD: 1200 // 违规词错误
};

// HTTP 状态码
export const HTTP_STATUS = {
  OK: 200,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500
};

/**
 * 用户相关常量
 */

// 用户类型
export const USER_TYPE = {
  ADMIN: 1, // 管理员
  NORMAL: 2 // 普通用户
};

// 用户状态
export const USER_STATUS = {
  DISABLED: 0, // 停用
  ENABLED: 1 // 启用
};

// 用户状态文本映射
export const USER_STATUS_TEXT = {
  [USER_STATUS.DISABLED]: '已停用',
  [USER_STATUS.ENABLED]: '正常'
};

/**
 * 请求超时配置
 */
export const REQUEST_TIMEOUT = {
  NORMAL: 15000, // 普通请求超时 15s
  AI: 30000 // AI 请求超时 30s
};
